export const RTC_CONFIGURATION_LINK = 'https://positioningservices.trimble.com/industries/mapping-gis/';
export const RTC_TRIMBLERTX_INFO_LINK = 'https://positioningservices.trimble.com/services/rtx/';
export const RTC_SATELLITERTX_INFO_LINK = 'https://positioningservices.trimble.com/services/rtx/';
export const RTC_INTERNET_INFO_LINK = 'https://positioningservices.trimble.com/services/vrs/';
